var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBNav2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.54,
    height: 19.191,
    viewBox: "0 0 18.54 19.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b-nav-2",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M22.528,5.151A2.154,2.154,0,0,0,20.388,3H9.784A2.157,2.157,0,0,0,7.64,5.151v6.783H4.331a.331.331,0,0,0-.331.33V16.83a2.157,2.157,0,0,0,2.154,2.154h5.125v1.591a.377.377,0,0,0,.056.185l.883,1.274a.33.33,0,0,0,.543,0l.612-.88.612.88a.324.324,0,0,0,.543.013l.612-.88.612.88a.33.33,0,0,0,.543,0l.609-.88.609.88a.331.331,0,0,0,.546,0l.612-.88.612.88a.331.331,0,0,0,.543,0l.612-.88.612.88a.33.33,0,0,0,.543,0l.887-1.271a.45.45,0,0,0,.06-.189ZM4.662,16.843V12.6H7.64v4.23a1.492,1.492,0,0,1-2.978,0ZM7.7,18.336a2.144,2.144,0,0,0,.6-1.492V5.154a1.489,1.489,0,0,1,2.978,0V18.336ZM21.337,21.28l-.612-.883a.331.331,0,0,0-.543,0l-.632.883-.612-.883a.331.331,0,0,0-.546,0l-.609.883-.612-.883a.33.33,0,0,0-.543,0l-.612.883L15.4,20.4a.331.331,0,0,0-.543,0l-.605.883L13.64,20.4a.33.33,0,0,0-.543,0l-.612.883-.549-.794V5.151a2.141,2.141,0,0,0-.605-1.489h9.052a1.492,1.492,0,0,1,1.479,1.489V20.483Z",
    fill: "#095682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M40.648,13.99H40.1a.364.364,0,0,1-.374-.354.331.331,0,0,1,.106-.248.4.4,0,0,1,.268-.106h1.036a.331.331,0,1,0,0-.662H40.7v-.45a.331.331,0,0,0-.662,0v.457a1.029,1.029,0,0,0-.662.288.993.993,0,0,0-.308.721A1.026,1.026,0,0,0,40.1,14.652h.546a.367.367,0,0,1,.38.354.331.331,0,0,1-.106.245.384.384,0,0,1-.271.106h-1.04a.331.331,0,1,0,0,.662h.427v.453a.331.331,0,1,0,.662,0v-.457a1.059,1.059,0,0,0,.662-.288,1.012,1.012,0,0,0,.331-.721,1.029,1.029,0,0,0-1.046-1.016Z",
    transform: "translate(-23.467 -5.915)",
    fill: "#095682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M35.76,8.51a3.587,3.587,0,1,0,2.535,1.049A3.587,3.587,0,0,0,35.76,8.51Zm0,6.5a2.925,2.925,0,1,1,2.063-.858A2.925,2.925,0,0,1,35.76,15.01Z",
    transform: "translate(-18.856 -3.687)",
    fill: "#095682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M31.331,35.592H34.64a.331.331,0,1,0,0-.662H31.331a.331.331,0,0,0,0,.662Z",
    transform: "translate(-18.067 -21.366)",
    fill: "#095682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M37.948,39.7H31.331a.331.331,0,1,0,0,.662h6.617a.331.331,0,0,0,0-.662Z",
    transform: "translate(-18.067 -24.557)",
    fill: "#095682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M37.948,44.46H31.331a.331.331,0,1,0,0,.662h6.617a.331.331,0,0,0,0-.662Z",
    transform: "translate(-18.067 -27.742)",
    fill: "#095682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M37.948,49.22H31.331a.331.331,0,1,0,0,.662h6.617a.331.331,0,0,0,0-.662Z",
    transform: "translate(-18.067 -30.928)",
    fill: "#095682"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBNav2);
export default __webpack_public_path__ + "static/media/b-nav-2.8f04742368f4b0daace3d6b1df1c208b.svg";
export { ForwardRef as ReactComponent };